import React, { PureComponent } from 'react'

import { Button, ButtonColorVariant } from '@gousto-internal/citrus-react'
import copy from 'copy-to-clipboard'
import { CopyConfirmation } from 'SocialLinks/CopyConfirmation'
import { appendNativeShareUtm, shareNatively } from 'SocialLinks/shareNatively'
import { getMessage, getReferralLink, SHARE_TITLE, SOCIAL_TYPES } from 'SocialLinks/socialReferralHelper'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'

import { actionTypes } from 'actions/actionTypes'

import css from './SocialShareSheetCTA.css'

const propTypes = {
  referralCode: PropTypes.string.isRequired,
  isFixed: PropTypes.bool.isRequired,
  trackingReferFriend: PropTypes.func.isRequired,
  trackUserFreeFoodLinkShare: PropTypes.func.isRequired,
  surface: PropTypes.string.isRequired,
  rafOffer: ImmutablePropTypes.map.isRequired,
}

class SocialShareSheetCTA extends PureComponent {
  constructor(props) {
    super(props)
    this.state = { isCopied: false }
  }

  onClick = (referralLink) => {
    const { rafOffer, referralCode, surface, trackingReferFriend } = this.props

    shareNatively({
      payload: {
        title: SHARE_TITLE,
        url: appendNativeShareUtm(getReferralLink(referralCode)),
        text: getMessage(rafOffer),
      },
      surface,
      onOpened: () =>
        trackingReferFriend(
          actionTypes.REFER_FRIEND_LINK_SHARE,
          'NativeReferFriendInterface Opened',
        ),
      onFallback: () => this.onFallback(referralLink),
    })
  }

  onFallback = (referralLink) => {
    const { trackingReferFriend, trackUserFreeFoodLinkShare } = this.props

    if (!copy(referralLink)) {
      return
    }

    trackingReferFriend(actionTypes.REFER_FRIEND_LINK_COPIED, 'ReferFriendLink Copied')
    trackUserFreeFoodLinkShare({ target: SOCIAL_TYPES.link })
    this.setState({ isCopied: true })
  }

  render() {
    const { isCopied } = this.state
    const { referralCode, isFixed, rafOffer } = this.props
    const ctaContainerClasses = classnames(css.mobileShow, css.ctaContainer, {
      [css.fixedMobileCTAContainer]: isFixed,
    })

    const referralLink = getReferralLink(referralCode, '', '&utm_source=weblink')
    const credit = rafOffer.get('creditFormatted')

    return (
      <div className={ctaContainerClasses}>
        <Button
          onClick={() => this.onClick(referralLink)}
          colorVariant={ButtonColorVariant.Secondary}
          width="100%"
        >
          Share your link
        </Button>
        {isCopied && <CopyConfirmation credit={credit} />}
      </div>
    )
  }
}

SocialShareSheetCTA.propTypes = propTypes

export { SocialShareSheetCTA }
